import { CLIENTES } from '../actions/types';

const initialState = {
    listado: [],
    listado_avanzado: [],
    detalles: null, 
    ventana_filtros: false, 
    filtros: null, 
    detalles_archivo: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case CLIENTES.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case CLIENTES.BUSCAR_AVANZADO:
            return {
                ...state,
                listado_avanzado: payload
            };

        case CLIENTES.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case CLIENTES.MEMBRESIA:
            return {
                ...state, 
                detalles: {
                    ...state.detalles, 
                    indicadores_generales: {
                        ...state.detalles.indicadores_generales, 
                        membresia_actual: payload
                    }, 
                    contrataciones: [
                        payload,
                        ...state.detalles.contrataciones.slice(payload.status == 0 ? 0 : 1)
                    ]
                }
            };

        case CLIENTES.MEMBRESIAS:
            return {
                ...state, 
                detalles: {
                    ...state.detalles, 
                    indicadores_generales: {
                        ...state.detalles.indicadores_generales, 
                        membresia_actual: payload.actual
                    }, 
                    contrataciones: payload.membresias
                }
            };

        case CLIENTES.DESACTIVAR_RENOVACION:
            return {
                ...state,
                detalles: {
                    ...state.detalles,
                    indicadores_generales: {
                        ...state.detalles.indicadores_generales,
                        membresia_actual: {
                            ...state.detalles.indicadores_generales.membresia_actual,
                            cancel_at_period_end: true
                        }
                    },
                    contrataciones: state.detalles.contrataciones.map(c =>
                        String(c._id) === String(payload.id_contratacion)
                            ? { ...c, cancel_at_period_end: true }
                            : c
                    )
                }
            };

        case CLIENTES.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( joven => joven._id !== payload.id )
            };

        case CLIENTES.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        case CLIENTES.ARCHIVOS.LISTAR:
            return {
                detalles: {
                    ...state.detalles, 
                    archivos: [
                        ...payload
                    ]
                }
            };

        case CLIENTES.ARCHIVOS.DETALLES:
            return {
                ...state,
                detalles_archivo: payload
            };

        default:
            return state;
    }
}